import { defineMessages } from 'react-intl'

const scope = 'app.components.BusinessActivity'

export default defineMessages({
  relationship: {
    id: `${scope}.relationship`,
    defaultMessage: 'Relationship',
  },
  projectPriceAsString: {
    id: `${scope}.projectPriceAsString`,
    defaultMessage: 'Project Price',
  },
  status: {
    id: `${scope}.status`,
    defaultMessage: 'Project Status',
  },
  valuation: {
    id: `${scope}.valuation`,
    defaultMessage: 'Project Value',
  },
  totalCharges: {
    id: `${scope}.totalCharges`,
    defaultMessage: 'Total Charges',
  },
  cost: {
    id: `${scope}.cost`,
    defaultMessage: 'Cost',
  },
  costRange: {
    id: `${scope}.costRange`,
    defaultMessage: 'Cost Range',
  },
})
